import styles from './toggleButtonGroup.module.scss';
import type { ToggleButtonGroupSize, ToggleButtonGroupTheme, ToggleButtonGroupOrientation } from './types';

export const groupRadiusClassMap: Record<ToggleButtonGroupSize, string> = {
  XS: styles.radiusXS,
  S: styles.radiusS,
  M: styles.radiusM,
};

export const groupThemeClassMap: Record<ToggleButtonGroupTheme, string> = {
  light: styles.themeLight,
  finsight: styles.themeFinsight,
};

export const groupOrientationClassMap: Record<ToggleButtonGroupOrientation, string> = {
  horizontal: styles.orientationHorizontal,
  vertical: styles.orientationVertical,
};

export const groupFitClassMap: Record<string, string> = {
  fitInline: styles.fitInline,
  fitFull: styles.fitFull,
  fitSmInline: styles.fitSmInline,
  fitSmFull: styles.fitSmFull,
  fitMdInline: styles.fitMdInline,
  fitMdFull: styles.fitMdFull,
  fitXlInline: styles.fitXlInline,
  fitXlFull: styles.fitXlFull,
};

export const groupItemSizeClassMap: Record<ToggleButtonGroupSize, string> = {
  XS: styles.sizeXS,
  S: styles.sizeS,
  M: styles.sizeM,
};

export const groupItemThemeClassMap: Record<ToggleButtonGroupTheme, string> = {
  light: styles.itemThemeLight,
  finsight: styles.itemThemeFinsight,
};
